import script from "./AditionalData.vue?vue&type=script&setup=true&lang=js"
export * from "./AditionalData.vue?vue&type=script&setup=true&lang=js"

import "./AditionalData.vue?vue&type=style&index=0&id=97ffc9de&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97ffc9de"]])

export default __exports__